export default __webpack_public_path__ + "static/media/complete.fea48932.png";